import { Auth } from '@aws-amplify/auth'
import getFQDN from '../rest'
import LOG from '../../logging/Logger'

export async function createStripeCustomer(
  currentUser,
  handleSubscriptionError
) {
  const createCustResult = await fetch(getFQDN('v1/create-customer'), {
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      email: currentUser.attributes.email
    })
  })
  const stripeCustomer = await createCustResult.json()

  if (stripeCustomer) {
    if (stripeCustomer.error) {
      LOG.error('stripeCustomer:', stripeCustomer.error)
      if (handleSubscriptionError) {
        return handleSubscriptionError(stripeCustomer)
      }
      return
    }
    LOG.debug('stripeCustomer:', stripeCustomer)

    const customerId = stripeCustomer.customer.id
    const updateUserResult = await Auth.updateUserAttributes(currentUser, {
      'custom:stripeCustId': customerId
    })
    LOG.debug('result:', updateUserResult)
    return customerId
  }
}

export async function getStripeCustomerID(handleSubscriptionError) {
  try {
    const currentUser = await Auth.currentAuthenticatedUser()
    LOG.debug('currentUser:', currentUser)
    let customerId = currentUser.attributes['custom:stripeCustId']

    LOG.debug('pre customerId:', customerId)

    if (!customerId) {
      customerId = createStripeCustomer(currentUser, handleSubscriptionError)
    }
    return customerId
  } catch (error) {
    LOG.error('getStripeCustomerID error: ', error)
  }
}

function convertUnixDateToIso(uDt) {
  // Create a new JavaScript Date object based on the timestamp
  // multiplied by 1000 so that the argument is in milliseconds, not seconds.
  const date = new Date(uDt * 1000)
  return date.toISOString()
}

export async function setSubscriptionEndedDetails(endDate) {
  const currentUser = await Auth.currentAuthenticatedUser()
  try {
    const updateUserResult = await Auth.updateUserAttributes(currentUser, {
      'custom:stripeProductId': '',
      'custom:stripeSubscriptionId': '',
      'custom:stripeSubEndDt': convertUnixDateToIso(endDate)
    })
    LOG.debug('result:', updateUserResult)
  } catch (error) {
    LOG.debug('setSubscriptionEndedDetails failure:', error)
  }
}

export async function resetStripeCustomer() {
  const currentUser = await Auth.currentAuthenticatedUser()
  const deleteResult = currentUser.deleteAttributes([
    'custom:stripeCardNumber',
    'custom:stripeCustId',
    'custom:stripeProductId',
    'custom:stripePayMethodId',
    'custom:stripeSubEndDt',
    'custom:stripeSubscriptionId'
  ])
  LOG.debug('updateUserResult', deleteResult)
}

export default getStripeCustomerID
